import React from 'react';
import { motion } from 'framer-motion';
import { FaCode, FaMicrochip, FaCogs, FaDatabase } from 'react-icons/fa';
import { staggerContainer, staggerItem } from '../../utils/animations';
import Section from '../../Components/common/Section';
import ServiceCard from '../../Components/common/ServiceCard';
import GradientText from '../../Components/common/GradientText';

const SoftwareServices = () => {
  const services = [
    {
      icon: FaCode,
      title: 'Custom Web Applications',
      description: 'Full-stack development with modern frameworks. Responsive, scalable, and cloud-ready applications.',
      link: '/services',
    },
    {
      icon: FaMicrochip,
      title: 'AI/ML Integrations',
      description: 'Integrate powerful AI capabilities into your existing systems. ChatGPT, computer vision, NLP, and more.',
      link: '/services',
    },
    {
      icon: FaCogs,
      title: 'Business Automation Tools',
      description: 'Automate repetitive tasks and workflows. Save time, reduce errors, and boost productivity.',
      link: '/services',
    },
    {
      icon: FaDatabase,
      title: 'SaaS & Dashboards',
      description: 'Build multi-tenant SaaS platforms and real-time analytics dashboards for data-driven decisions.',
      link: '/services',
    },
  ];

  return (
    <Section background="white">
      <motion.div
        variants={staggerContainer}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.2 }}
      >
        <motion.div variants={staggerItem} className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            <GradientText>Software Development</GradientText> Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Custom AI integrations, web apps, and automation solutions for your business
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <motion.div key={index} variants={staggerItem}>
              <ServiceCard {...service} />
            </motion.div>
          ))}
        </div>
      </motion.div>
    </Section>
  );
};

export default SoftwareServices;
